import { render, staticRenderFns } from "./DataValue.vue?vue&type=template&id=2cb8f512&scoped=true"
import script from "./DataValue.vue?vue&type=script&lang=js"
export * from "./DataValue.vue?vue&type=script&lang=js"
import style0 from "./DataValue.vue?vue&type=style&index=0&id=2cb8f512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8f512",
  null
  
)

export default component.exports